import { Injectable } from '@angular/core';
import { Jsonp, Http, URLSearchParams, Response, RequestOptions, RequestOptionsArgs, RequestMethod, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switchMap';

import { AppSettings } from "./config.services";

@Injectable()
export class SearchService {

  constructor(
    private jsonp: Jsonp,
    private http: Http
  ) { }

  public search(term: string) {
    let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/FiltersWebService.asmx/GetLeyes';

    let params = new URLSearchParams();
    params.set('q', term); // the user's search value
    params.set('callback', 'JSONP_CALLBACK');

    // TODO: Add error handling
    return this.jsonp
      .get(serviceUrl, { search: params })
      .map(response => response.json());
  }

  public getEntidades() {
    let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/FiltersWebService.asmx/GetEntidadesEmisorasJSON';
    // TODO: Add error handling
    return this.http
      .get(serviceUrl)
      .map(response => response.json());
  }

  public getTiposDocumento() {
    let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/FiltersWebService.asmx/GetTiposDocumentoJSON';
    // TODO: Add error handling
    return this.http
      .get(serviceUrl)
      .map(response => response.json());
  }

  public getFacetedSearchDocument(query: string) {
    let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/FiltersWebService.asmx/GetFacetedSearchDocumentJSON';

    let params = new URLSearchParams();
    params.set('q', query); // the user's search value
    params.set('s', '0');
    params.set('l', '20');
    params.set('fs', '0');
    params.set('i', '0');
    params.set('_ng', (new Date().getTime()).toString());

    // var options = new RequestOptions({
    //   headers: new Headers({
    //     'Accept': 'application/json'
    //   })
    // });

    // TODO: Add error handling
    return this.http
      .get(serviceUrl, { search: params })
      .map(response => {
        return response.json();
      })
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/services/search.service.ts